<template>
  <Card noBorder>
    <SectionHeader
      title="Password Recovery Email"
    >
      <ParagraphBody>
        {{ $options.instructions }}
      </ParagraphBody>
    </SectionHeader>
    <Checkbox
      v-model="enableRecoveryEmail"
      :label="$options.label"
    />
  </Card>
</template>
<script>
import {
  Card, Checkbox, ParagraphBody,
} from '@jumpcloud/ui-components';
import SectionHeader from 'client/settings/components/SectionHeader.vue';

export default {
  name: 'SectionPasswordRecoveryEmail',

  components: {
    Card,
    Checkbox,
    ParagraphBody,
    SectionHeader,
  },

  props: {
    value: {
      type: Object,
      default: () => {},
    },
  },

  computed: {
    enableRecoveryEmail: {
      get() {
        return this.value.passwordPolicy ? this.value.passwordPolicy.enableRecoveryEmail : false;
      },
      set(newValue) {
        this.$emit('input', {
          ...this.value,
          passwordPolicy: {
            ...this.value.passwordPolicy,
            enableRecoveryEmail: newValue,
          },
        });
      },
    },
  },

  instructions: 'This allows users to reset their password with a different email than their organization email. Password reset emails will be sent to both email addresses and resetting from the recovery email requires the user to authenticate with MFA. Recovery Email will always be editable by users in the User Portal.',
  label: 'Enable Password Recovery Email for users',
};
</script>
